import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-loading-button',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './loading-button.component.html',
  styleUrls: ['./loading-button.component.scss'],
})
export class LoadingButtonComponent implements OnChanges {
  @Input() loading = false;
  @Input() disabled = false;
  @Input() debounceMs = 400;
  @Input() fill?: string;
  @Input() color?: string;
  @Input() size?: string;
  @Input() expand?: string;
  @Input() type?: string;
  @Input() ariaLabel?: string;
  @Input() loadingAriaLabel = 'Loading';
  @Input('data-testid') testId?: string;
  @Input() slot: string | null = null;

  @Output() clicked = new EventEmitter<Event>();

  private pendingClick = false;
  private pendingTimeout: ReturnType<typeof setTimeout> | null = null;

  @HostBinding('attr.slot') get hostSlot(): string | null {
    return this.slot;
  }

  @HostBinding('class.block') get isBlock(): boolean {
    return this.expand === 'block' || this.expand === 'full';
  }

  get isDisabled(): boolean {
    return this.disabled || this.loading || this.pendingClick;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loading'] && !this.loading) {
      this.clearPendingClick();
    }
  }

  handleClick(event: Event): void {
    if (this.isDisabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    this.pendingClick = true;
    if (this.pendingTimeout) {
      clearTimeout(this.pendingTimeout);
    }
    this.pendingTimeout = setTimeout(() => {
      this.clearPendingClick();
    }, Math.max(0, this.debounceMs));
    this.clicked.emit(event);
  }

  private clearPendingClick(): void {
    this.pendingClick = false;
    if (this.pendingTimeout) {
      clearTimeout(this.pendingTimeout);
      this.pendingTimeout = null;
    }
  }
}
